import styled from 'styled-components'

export const List = styled.ul`
  ${({ theme: { colors, space } }): string => `
padding: 0;
margin: 0;
line-height: 1.5;

  &:not(:first-of-type) {
    margin-top: ${space.sm};
    padding-top: ${space.sm};
    border-top: 1px solid ${colors['slate-2']};
  }
`};
`

export const ListItem = styled.li`
  ${({ theme: { colors, space } }): string => `
  list-style: none;
  display: flex;
  padding: ${space.sm} 0;
  border-bottom: 1px solid ${colors['slate-2']};

  &:first-of-type {
    padding-top: 0;
  }

  &:last-child {
    padding-bottom: 0;
    border-bottom: none;
  }
`};
`
